.page {
    max-width: 560px;
}

.header {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0 0 28px;
}

.heading {
    margin: 0;
}

.headingRow {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
}

.headingActions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.deleteConfirmRow {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
}

.form {
    display: contents;
}

/* Fields */

.fields {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.hint {
    margin: 0;
    font-size: 12px;
}

/* Actions */

.actions {
    gap: 12px;
    display: flex;
    justify-content: flex-end;
    padding: calc(var(--exo-spacing-standard) - var(--exo-spacing-3x-small)) var(--exo-spacing-none);
    border-top: var(--exo-spacing-4x-small) solid var(--exo-color-border-secondary);
    margin: var(--exo-spacing-none) var(--exo-spacing-medium);
}

.cancelButton {
    font-family: inherit;
    font-size: 13px;
    font-weight: 500;
    line-height: inherit;
    color: var(--exo-color-font);
    text-decoration: none;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
}

.deleteConfirmText {
    margin-right: auto;
    font-size: 13px;
    font-weight: 500;
    color: var(--exo-color-font);
}

/* Credentials */

.credentials {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 20px;
}

.credentialField {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.credentialLabel {
    font-size: 12px;
    font-weight: 600;
    color: var(--exo-color-font-secondary);
    text-transform: uppercase;
    letter-spacing: 0.04em;
}

.credentialValue {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border: 1px solid var(--exo-color-border-secondary);
    border-radius: 8px;
    background: var(--exo-color-background-secondary);
}

.credentialCode {
    flex: 1;
    font-family: monospace;
    font-size: 13px;
    word-break: break-all;
    color: var(--exo-color-font);
}

.copyButton {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border: none;
    background: none;
    cursor: pointer;
    color: var(--exo-color-font-secondary);
    border-radius: 4px;
}

.copyButton:hover {
    background: var(--exo-color-background-tertiary);
    color: var(--exo-color-font);
}

/* Section heading */

.sectionHeading {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--exo-color-font);
}

/* Error */

.saveError {
    margin-top: 30px;
    display: block;
}
